// import ajax from '@/api/ajax'

// 发送请求方法
function ajax(url, method, data, cb) {
    var xmlhttp;
    if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
    } else {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }

    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4) {
            if (xmlhttp.status !== 200) {
                console.log(xmlhttp.status + ':' + xmlhttp.statusText);
                cb(new Error(xmlhttp.status));
                return;
            }
            cb(null, xmlhttp.responseText);
            return;
        }
    }
    xmlhttp.open(method, url, true);
    if (method === 'POST') {
        xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    }
    if(data) {
        xmlhttp.send(data);
    }else {
        xmlhttp.send();
    }
}

const utils = {
    getQueryString: (name) => {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r;
        if(window.location.search){
             r = window.location.search.substr(1).match(reg);
        }
        r = window.location.hash.split('?').length>1 && window.location.hash.split('?')[1].match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },
    //是否为ios
    isIOS: () => {
        let u = navigator.userAgent;
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    } 
}

export default utils


// WEBPACK FOOTER //
// ./src/base/utils.js